<template>
	<v-container fluid class="height-100">
		<v-card elevation="0" class=" height-100">
			<v-card-title>
				<v-icon class="mr-2" color="blue">mdi-widgets</v-icon>
				应用管理<v-spacer />
				<v-text-field v-model="appName" @change="selectAppByName" @click:append="selectAppByName" style="max-width: 380px" placeholder="请输入应用名称查询" outlined dense hide-details append-icon="mdi-feature-search-outline"></v-text-field>
			</v-card-title>
			<v-card-text>
				<v-banner class="px-2 py-2 blue--text rounded mb-4" icon-color="blue" height="42" :color="$vuetify.theme.dark ? 'grey darken-3' : 'blue lighten-5'" tile single-line rounded outlined>
					<v-icon color="blue" style="vertical-align: sub">mdi-alert-circle-outline</v-icon>
					请先申请对应应用的公司资质，方可访问对应应用
				</v-banner>
				<v-row class="pr-1">
					<v-col v-if="user.acidIs == '1'" cols="12" xl="3" lg="3" md="4" sm="6" xs="12" class="pb-2 pr-2">
						<v-list-item class="appItems rounded-lg pb-8" three-line to="/uams/apps">
							<v-list-item-avatar color="blue-grey lighten-5" size="72" style="border-radius: 12px">
								<v-icon color="primary" size="36">mdi-hammer-wrench</v-icon>
							</v-list-item-avatar>
							<v-list-item-content>
								<v-list-item-title class="title font-weight-regular mb-1"> 应用开放平台 </v-list-item-title>
								<v-list-item-subtitle style="line-height: unset"
									>为残联信息化开发商提供一个通用技术服务的基础平台，主要包括应用注册、视图设置、菜单配置、开发文档等相关功能，提高残联应用建设的规范性和便捷性，为残疾人事业数字化改革奠定坚实基础。</v-list-item-subtitle
								>
								<v-subheader class="sub_title grey--text caption"> 全局<v-spacer />2022/09/01</v-subheader>
							</v-list-item-content>
						</v-list-item>
					</v-col>
					<v-col v-for="(item, index) in apps" :key="index" cols="12" xl="3" lg="3" md="4" sm="6" xs="12" class="pb-2 pr-2">
						<v-list-item class="appItems rounded-lg pb-8" three-line @click="toPage(item)">
							<v-list-item-avatar color="blue-grey lighten-5" size="72" style="border-radius: 12px">
								<v-icon :style="item.pscss" size="36">{{ item.props }}</v-icon>
							</v-list-item-avatar>
							<v-list-item-content>
								<v-list-item-title class="title font-weight-regular mb-1">{{ item.name }}</v-list-item-title>
								<v-list-item-subtitle style="line-height: unset">{{ item.note }}</v-list-item-subtitle>
								<v-subheader class="sub_title grey--text caption"> {{ item.leve | dict("0:国家/2:省级/4:市级/6:区县") }}<v-spacer />{{ item.operateTime | date("yyyy/MM/dd") }}</v-subheader>
							</v-list-item-content>
						</v-list-item>
					</v-col>
					<v-col v-if="user.acidIs == '0' && apps.length < 1" cols="12" md="12" class="pr-1 pb-0 pt-1 text-center grey--text">
						<v-img class="mx-auto mb-4 mt-12" src="../../assets/img/noData.png" max-width="300px"></v-img>
						暂无应用信息
					</v-col>
				</v-row>
			</v-card-text>
		</v-card>
	</v-container>
</template>

<script>
import Storage from "@/commons/storage";
import Request from "@/commons/request";
import toPage from "@/commons/urlstoken";
export default {
	name: "DashServ",
	data() {
		return {
			toPage,
			apps: [],
			msgs: [],
			appList: [],
			appName: "",
			user: {},
		};
	},
	mounted() {
		this.user = Storage.get("_wit_acis_users");
		Request.postForm("view/vmain/serv").then(
			(res) => {
				this.apps = res.data.apps;
				this.msgs = res.data.msgs;
			},
			(err) => {
				console.log(err);
			}
		);
	},
	methods: {
		//检索
		selectAppByName() {
			if (this.appList.length <= 0) {
				this.appList = this.apps;
			}
			this.apps = this.appName ? this.appList.filter((item) => item.name.indexOf(this.appName) >= 0) : this.appList;
		},
	},
};
</script>

<style lang="scss" scoped>
.appItems {
	border: 1px solid #99999952 !important;
}
.sub_title {
	position: absolute;
	bottom: 0;
	left: 0;
	width: 100%;
}
.border-dashed {
	border: 1px #2196f3 dashed;
}
.border-solid {
	border: 1px rgba(182, 182, 182, 0.6) solid;
}
::v-deep .v-banner--single-line .v-banner__wrapper {
	padding: 0 !important;
}
</style>
